import { AxiosError } from "axios"
import { useState } from "react"
import { toast } from "sonner"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { loginWithEmail } from "@/modules/api/auth.api"
import { useAuthStore } from "@/modules/helpers/hooks/shared"

export const DevLoginForm = () => {
  const login = useAuthStore((state) => state.login)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const trimmedEmail = email.trim()
    if (!trimmedEmail || !password) {
      toast.error("Vui lòng nhập email và mật khẩu")
      return
    }

    setIsSubmitting(true)
    try {
      const { data } = await loginWithEmail({
        email: trimmedEmail,
        password
      })

      const { accessToken, refreshToken, isNewUser } = data?.data ?? {}

      if (!accessToken || !refreshToken) {
        toast.error("Đăng nhập thất bại: thiếu token")
        return
      }

      login({ accessToken, refreshToken, isNewUser })
      toast.success("Đăng nhập thành công")
    } catch (error) {
      const message =
        error instanceof AxiosError
          ? (error.response?.data?.message ?? error.message)
          : "Đăng nhập thất bại"
      toast.error(String(message))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-neutral-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Dev login</CardTitle>
          <CardDescription>
            Chế độ phát triển — đăng nhập bằng email và mật khẩu (không cần app native).
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-2">
              <Label htmlFor="dev-login-email">Email</Label>
              <Input
                id="dev-login-email"
                type="email"
                autoComplete="email"
                placeholder="email@example.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                disabled={isSubmitting}
                tabIndex={0}
              />
            </div>
            <div className="flex flex-col gap-2">
              <Label htmlFor="dev-login-password">Mật khẩu</Label>
              <Input
                id="dev-login-password"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                disabled={isSubmitting}
                tabIndex={0}
              />
            </div>
            <Button type="submit" className="w-full" disabled={isSubmitting}>
              {isSubmitting ? "Đang đăng nhập..." : "Đăng nhập"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
